module.exports = __webpack_public_path__ + "img/banner-hp-mcafee-web.17ab783c.svg";